module.exports = __webpack_public_path__ + "static/img/1.aa1cbd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/1.png
// module id = IpR4
// module chunks = 0